import Loading from "../../Loading";
import { Fragment } from "react";

function FixtureLegs() {
  return <div className="page">FixtureLegs</div>;
}

export default FixtureLegs;
